<template>
    <div
        class="Language"
        v-click-outside="hideDropdown">
        <div
            class="Language-languageDropdown"
            :class="{ 'Language-languageDropdown--active': expandedOptions }"
            @click.prevent="expandOptions">
            <component :is="selectedFlag(currentOption)"/>
        </div>
        <ul
            class="Language-languageOptions"
            :class="{ 'Language-languageOptions--active': expandedOptions }"
        >
            <li
                v-for="option in filteredCountries"
                class="Language-languageOption"
                @click.stop="selectOption(option)"
            >
                <component
                    :is="selectedFlag(option.label)"
                    class="Language-flag"/>
                {{ option.label }}
            </li>
        </ul>
    </div>
</template>
<script>
import Denmark from './assets/da-DK'
import Germany from './assets/de-DE'
import Greece from './assets/el-GR'
import UK from './assets/en-GB'
import US from './assets/en-US'
import Canada from './assets/en-CA'
import Spain from './assets/es-ES'
import Finland from './assets/fi-FI'
import Croatia from './assets/hr-HR'
import Norway from './assets/nb-NO'
import Netherlands from './assets/nl-NL'
import Sweden from './assets/sv-SE'
import France from './assets/fr-FR'

export default {
    name: 'HempelLanguage',
    data() {
        return {
            expandedOptions: false,
            selectedOption: '',
            countries: [
                { label: 'UK', value: 'en-GB' },
                { label: 'US', value: 'en-US' },
                { label: 'Canada', value: 'en-CA' },
                { label: 'Denmark', value: 'da-DK' },
                { label: 'Spain', value: 'es-ES' },
                { label: 'Finland', value: 'fi-FI' },
                { label: 'Germany', value: 'de-DE' },
                { label: 'Greece', value: 'el-GR' },
                { label: 'Croatia', value: 'hr-HR' },
                { label: 'Norway', value: 'nb-NO' },
                { label: 'Netherlands', value: 'nl-NL' },
                { label: 'Sweden', value: 'sv-SE' },
                { label: 'France', value: 'fr-FR' }
            ],
            flags: {
                Denmark,
                Germany,
                Greece,
                UK,
                US,
                Canada,
                Spain,
                Finland,
                Croatia,
                Norway,
                Netherlands,
                Sweden,
                France
            }
        }
    },
    props: {
        value: {
            type: [Number, String]
        }
    },
    computed: {
        currentOption() {
            const selectedCountry = this.countries.filter(
                country => country.value === `${this.detectedLanguage}`
            )
            return this.selectedOption.length > 0 ? this.selectedOption : selectedCountry[0].label
        },
        filteredCountries() {
            return this.countries.filter(country => country.label !== this.currentOption)
        }
    },
    methods: {
        onChange(e) {
            this.$emit('input', {
                value: e.target.value
            })
        },
        expandOptions() {
            this.expandedOptions = !this.expandedOptions
        },
        hideDropdown() {
            this.expandedOptions = false
        },
        selectOption(option) {
            this.selectedOption = option.label
            this.expandedOptions = false
            this.setCurrentLanguage(`${option.value}`)
            this.setTranslation(this.$content[`${option.value}`])
        },
        getCountry(value) {
            return this.countries.filter(option => option.value === `${value}`).label
        },
        selectedFlag(option) {
            return this.flags[option]
        }
    }
}
</script>
